import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Register from '@/views/Register.vue'
import Login from '@/views/Login.vue'
import PasswordForgotten from '@/views/PasswordForgotten.vue'
import PasswordReset from '@/views/PasswordReset.vue'
import Home from '@/views/Home.vue'
import Profile from '@/views/Profile.vue'
import PasswordChange from '@/views/PasswordChange.vue'
import Video from '@/views/Video.vue'
import Sessions from '@/views/Sessions.vue'
import Demos from '@/views/Demos.vue'
import SessionsUserFavorites from '@/views/SessionsUserFavorites.vue'
import SessionsUserHistory from '@/views/SessionsUserHistory.vue'
import SharedFavorites from '@/views/SharedFavorites.vue'
import Speakers from '@/views/Speakers.vue'
import PageNotFound from '@/views/PageNotFound'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/registro',
    name: 'Register',
    component: Register,
    meta: {
      requiresAnon: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresAnon: true,
    },
  },
  {
    path: '/contrasena-olvidada',
    name: 'PasswordForgotten',
    component: PasswordForgotten,
    meta: {
      requiresAnon: true,
    },
  },
  {
    path: '/restauracion-contrasena',
    name: 'PasswordReset',
    component: PasswordReset,
    meta: {
      requiresAnon: true,
    },
  },
  {
    path: '/perfil',
    name: 'Profile',
    component: Profile,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/cambiar-contrasena',
    name: 'PasswordChange',
    component: PasswordChange,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/sesiones/:slug?',
    name: 'Sessions',
    component: Sessions,
    props: true,
  },
  {
    path: '/demos/:slug?',
    name: 'Demos',
    component: Demos,
    props: true,
  },
  {
    path: '/mis-favoritos',
    name: 'Favorites',
    component: SessionsUserFavorites,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/historial',
    name: 'History',
    component: SessionsUserHistory,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/mis-favoritos/:ids',
    name: 'SharedFavorites',
    component: SharedFavorites,
    props: true,
  },
  {
    path: '/ponentes',
    name: 'Speakers',
    component: Speakers,
  },
  {
    path: '/video/:slug',
    name: 'Video',
    component: Video,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: PageNotFound,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes,
})

function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}

router.beforeEach((to, from, next) => {
  if (hasQueryParams(to)) {
    const utm_params_names = store.state.utm_params_names
    const params = to.query

    utm_params_names.forEach(param => {
      if (param in params) {
        localStorage.setItem(param, params[param])
      }
    })
  }

  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (store.getters['auth/userIsAuthenticated']) {
      next()
    } else {
      store.dispatch('auth/logOut').then(() => {
        next({ name: 'Login', query: { next: to.path } })
      })
    }
  } else if (to.matched.some(route => route.meta.requiresAnon)) {
    if (store.getters['auth/userIsAuthenticated']) {
      next({ name: 'Home' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
